const CHANGE_TYPES = { Created: 'Creación', Changed: 'Modificación', Deleted: 'Eliminación' };

// Campos relevantes a comparar entre registros (el estado no está: se muestra en el badge)
const TRACKED_FIELDS = {
    backoffice_manager: 'Encargado',
    causal_anulacion: 'Causal',
    observations_backoffice: 'Obs. backoffice',
    observations: 'Observaciones',
    plan: 'Plan',
    price_plan: 'Precio',
    address: 'Dirección',
    contact_phone: 'Celular',
    email_owner: 'Email',
    contract: 'Contrato:',
    phone_fijo: 'Fijo:',
    late_instalation: 'Instalación',
};
const FILE_FIELDS = ['ad_cc', 'ad_cc_back', 'rec_pub'];
const INLINE_FIELDS = new Set(['contract', 'phone_fijo']);

// null y '' se consideran el mismo "vacío"
const isSame = (a, b) => (a ?? '') === (b ?? '');

const getChanges = (record, prev) => {
    const changes = Object.entries(TRACKED_FIELDS)
        .filter(([key]) => !isSame(record[key], prev[key]))
        .map(([key, label]) => ({ key, label, value: record[key], inline: INLINE_FIELDS.has(key) }));
    if (FILE_FIELDS.some((key) => !isSame(record[key], prev[key]))) {
        changes.push({ key: 'files', label: 'Documentos', value: 'Modificados' });
    }
    return changes;
};

// history_change_reason solo existe en eventos nuevos; para los antiguos se deduce un título
const getTitle = (record, stateChanged) => {
    if (record.history_change_reason) return record.history_change_reason;
    if (stateChanged) return 'Cambio de estado';
    return record.history_type === 'Created' ? 'Creación de solicitud' : 'Modificación de solicitud';
};

const toEvent = (record, prev) => {
    const stateChanged = !!prev && !isSame(record.is_actived, prev.is_actived);
    return {
        id: record.history_id,
        title: getTitle(record, stateChanged),
        state: record.is_actived,
        date: record.history_date,
        user: record.history_user || 'Sistema',
        type: CHANGE_TYPES[record.history_type] ?? record.history_type,
        changes: prev ? getChanges(record, prev) : [],
    };
};

// Convierte los registros históricos de la API en eventos, del más reciente al más antiguo
export const buildTimeline = (records = []) => {
    const sorted = [...records].sort((a, b) => a.history_id - b.history_id);
    return sorted.map((record, i) => toEvent(record, sorted[i - 1])).reverse();
};
